import React, { useState } from "react";
import SvgImage from "../../../Icons/Icons";
import "./index.css";
import {
  downloadSalaryAction,
  downloadSalaryCreditSheet,
  uploadSalaryAction,
  uploadSalaryCreditSheet,
} from "../../../../services/Store/Actions/driverslistActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import {
  bulkAddDriverCompleteUpload,
  bulkAddDriverUpload,
} from "../../../../services/Store/Actions/walletAction";
import { FormCheck } from "react-bootstrap";
import { getDataFromAsyncStorage } from "../../../../services/Utils/functions";

function AddDriverBulk() {
  const [fileSave, setFileSave] = useState(null);
  const [loader, setLoader] = useState(false);
  const [bulkTransfer, setBulkTransfer] = useState(0);
  const [bulkTransferId, setBulkTransferId] = useState(null);
  const [isSalary, setIsSalary] = useState(false);
  const dispatch = useDispatch();
  const customId1 = "custom-id-download page";
  const notify1 = () =>
    toast.success("Template was downloaded successfully.", {
      toastId: customId1,
      pauseOnHover: false,
    });
  const customId2 = "custom-id-upload page";
  const notify2 = () =>
    toast.success(" Add Drivers Bulk File was updated successfully.", {
      toastId: customId2,
      pauseOnHover: false,
    });
  const customId3 = "custom-id-Salary-dispersed";
  const notify3 = () =>
    toast.success("Drivers Added successfully in Logipe", {
      toastId: customId3,
      pauseOnHover: false,
    });

  const downloadSalDisbursement = () => {
    let blob;
    if (isComplete) {
      blob = new Blob([
        "Phone Number" +
          "\t" +
          "Driver Name" +
          "\t" +
          "Driver Code" +
          "\t" +
          "Address" +
          "\t" +
          "City" +
          "\t" +
          "State" +
          "\t" +
          "PinCode" +
          "\t" +
          "Date Of Birth" +
          "\t" +
          "Gender" +
          "\t" +
          "Aadhar No" +
          "\n",
      ]);
    } else {
      blob = new Blob([
        "Phone Number" + "\t" + "Driver Name" + "\t" + "Driver Code" + "\n",
      ]);
    }

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `file.xls`; //name to changed here
    link.click();
    notify1();
  };
  const [isComplete, setIsComplete] = useState(false);
  const bulkTransferCall = async () => {
    console.log(isComplete, "isCompleteisCompleteisComplete");
    setLoader(true);
    if (isComplete) {
      const branchId = await getDataFromAsyncStorage("_branchId");
      dispatch(
        bulkAddDriverCompleteUpload({ file: fileSave, branchId }, (res) => {
          console.log("bulkAddDriverCompleteUpload", res);
          setLoader(false);
          if (res.status == 200) {
            //   const blob = new Blob([res?.data?.data])
            //   const link = document.createElement("a");
            //   link.href = window.URL.createObjectURL(blob);
            //   link.download = `responseFile.xls`; //name to changed here
            //   link.click();
            notify3();
          } else {
            toast.error(res.data?.message || "some error occured");
          }
        })
      );
    } else {
      const branchId = await getDataFromAsyncStorage("_branchId");
      dispatch(
        bulkAddDriverUpload({ file: fileSave, branchId }, (res) => {
          console.log("bulkAddDriverUpload", res);
          setLoader(false);
          if (res.status == 200) {
            // const blob = new Blob([res?.data?.data])
            // const link = document.createElement("a");
            // link.href = window.URL.createObjectURL(blob);
            // link.download = `responseFile.xls`; //name to changed here
            // link.click();
            notify3();
          } else {
            toast.error(res.data?.message || "some error occured");
          }
        })
      );
    }
  };
  return (
    <div style={{ width: "auto" }}>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: "-10px",
          }}
        >
          <FormCheck
            label={<span style={{ color: "orange" }}>Complete</span>}
            onChange={() => {
              setIsComplete(!isComplete);
            }}
            checked={isComplete}
          ></FormCheck>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            className="col-lg-6"
            style={{ padding: "10px" }}
            onClick={downloadSalDisbursement}
          >
            <div
              className="svgContainerUp"
              style={{ margin: "0 23px", filter: "invert(0)" }}
            >
              <SvgImage name="Download" />
            </div>
            <div
              className="Bold300"
              style={{ textAlign: "center", filter: "invert(0)" }}
            >
              Download Template
            </div>
          </div>
          <div className="col-lg-6" style={{ padding: "10px" }}>
            <label for="file-upload2" class="custom-file-upload3">
              <input
                id="file-upload2"
                type="file"
                onChange={async (e) => {
                  const img = e?.target.files[0];
                  setFileSave(img);
                  console.log("image", img?.name);
                  setBulkTransfer(1);
                  notify2();
                }}
              />
              <div
                className="svgContainerUp"
                style={{
                  margin: "0px 23px",
                  filter: "invert(0)",
                  backgroundColor: bulkTransfer > 0 ? "antiquewhite" : null,
                }}
              >
                <SvgImage name="Upload" />
              </div>
              <div
                className="Bold300"
                style={{ textAlign: "center", filter: "invert(0)" }}
              >
                Upload for Add Drivers
              </div>
            </label>
          </div>
        </div>
      </div>
      {bulkTransfer == 1 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "-10px",
          }}
        >
          <div style={{ margin: ".5rem" }}>
            <a disabled={loader} style={{ margin: ".5rem" }} href={fileSave}>
              {fileSave?.name || "test"}
            </a>
          </div>
          <div style={{}}>
            <input
              type="text"
              className=""
              name="bulkTransferId"
              placeholder="Enter Number Of Drivers"
              disabled={loader}
              onChange={(e) => {
                console.log(e.target.value);
                setBulkTransferId(e.target.value);
              }}
            />
          </div>
          <div>
            <Button
              className="greenButton"
              style={{ margin: ".5rem" }}
              onClick={bulkTransferCall}
              disabled={loader}
            >
              {" "}
              Add
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddDriverBulk;
